import { render } from "./InputGroups.vue?vue&type=template&id=706383cd"
import script from "./InputGroups.vue?vue&type=script&lang=js"
export * from "./InputGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__